import { TraxModal } from "~/shared/components/trax-modal/trax-modal.tsx";

type DeleteAddressModalProps = {
	readonly onClose: () => void;
	readonly onConfirm: () => void;
	readonly companyName: string;
};

export function DeleteAddressModal({
	onClose,
	onConfirm,
	companyName,
}: DeleteAddressModalProps) {
	return (
		<TraxModal
			onCancel={onClose}
			onClose={onClose}
			onConfirm={onConfirm}
			title={"Delete Address"}
			type={"confirmation"}
		>
			<p>
				Are you sure you want to delete <strong>{companyName}</strong> from your
				address book?
			</p>
		</TraxModal>
	);
}
